const errorStatusProvider = async (res) => {
  const responseStatus = res.status;
  if (res.ok) {
    const data = await res.json();
    return { data, responseStatus };
  }
  return { data: {}, responseStatus };
};

export default errorStatusProvider;
